var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243",
    transform: "translate(-5621 -3048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M5642.932,3056.74l-3.038-3.04a6.071,6.071,0,0,0-4.317-1.788h-3.937a4.367,4.367,0,0,0-4.361,4.36v13.456a4.366,4.366,0,0,0,4.361,4.36h8.72a4.366,4.366,0,0,0,4.361-4.36v-8.672A6.064,6.064,0,0,0,5642.932,3056.74Zm-5.188-2.487a4.351,4.351,0,0,1,.917.68l3.038,3.04a4.379,4.379,0,0,1,.681.916h-3.764a.872.872,0,0,1-.872-.872Zm5.233,15.475a2.617,2.617,0,0,1-2.617,2.616h-8.72a2.617,2.617,0,0,1-2.617-2.616v-13.456a2.617,2.617,0,0,1,2.617-2.616h3.937c.143,0,.282.028.423.041v4.32a2.616,2.616,0,0,0,2.616,2.616h4.32c.013.141.041.279.041.423Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_542",
    "data-name": "Rectangle 542",
    width: 30,
    height: 30,
    transform: "translate(5621 3048)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocuments);
export default __webpack_public_path__ + "static/media/icon-documents.977f2e446ba83654dcb42891f8afa3d3.svg";
export { ForwardRef as ReactComponent };